<template>
  <div class="lang-select-root flex items-center justify-center w-fit flex-wrap">
    <div class="w-fit relative">
      <div class="w-full rounded-lg overflow-hidden py-2 px-4 bg-white
        border border-gray-300 hover:bg-[var(--color-orange)] cursor-pointer"
        @click.prevent="toggleShowOptions">
        <div class="flex items-center justify-between h-6" id="yourself_right">
          <span :class="getFlagIcon(selectedLanguage)"/>
        </div>
      </div>
      <Transition name="lang-drop">
        <div v-if="getShowOptions" class="lang-dropdown" ref="dropdownRef">
          <ul class="w-full rounded-lg overflow-hidden py-2 px-4 bg-white
            border border-gray-300 shadow-lg" id="list-items">
            <li class="flex items-center justify-between w-full cursor-pointer
              py-3 px-1 hover:bg-[var(--color-orange)]" v-for="lang in languageOptions"
              :key="lang" @click.prevent="setLanguage(lang)">
              <span :class="getFlagIcon(lang)"/>
            </li>
          </ul>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageComponent',
  data() {
    return {
      showOptions: false,
      languageOptions: ['en', 'de'],
    };
  },
  computed: {
    getShowOptions() {
      return this.showOptions;
    },
    selectedLanguage() {
      return this.$store.state.auth.lang;
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleShowOptions() {
      this.showOptions = !this.showOptions;
    },
    handleClickOutside(e) {
      if (!this.showOptions) return;
      const root = this.$el;
      const dropdown = this.$refs.dropdownRef;
      if (root && dropdown && !root.contains(e.target)) {
        this.showOptions = false;
      }
    },
    getFlagIcon(key) {
      if (key === 'de') return 'fi fi-de';
      return 'fi fi-gb';
    },
    setLanguage(lang) {
      const validLocale = lang && ['en', 'de'].includes(lang) ? lang : 'en';
      this.$root.$i18n.locale = validLocale;
      localStorage.setItem('lang', validLocale);
      this.$store.commit('setLanguage', validLocale);
      this.$store.commit('setLocale', validLocale);
      this.showOptions = false;
    },
  },
};
</script>

<style scoped>
.lang-select-root {
  position: relative;
  z-index: 50;
}

.lang-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 0.25rem;
  z-index: 9999;
  min-width: 100%;
}

.lang-drop-enter-active,
.lang-drop-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.lang-drop-enter-from,
.lang-drop-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
